module.exports = __webpack_public_path__ + "static/media/13.363b3882.jpg";